import { useNode } from "@craftjs/core";
import * as React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import type { MediaItem } from "@/content-hub/page/domain";
import { getMediaUploadForTransaction } from "@/content-hub/store/selectors";
import { getAssetUrl } from "@/content-hub/utils";

import ImageSettings from "./image-settings";

export interface ImageProps {
  defaultSrc: string;
  alt?: string;
  height?: string;
  width?: string;
  blockType?: string;
  imageMetadata?: MediaItem;
}

export default function Image(props: ImageProps) {
  const {
    connectors: { connect },
    nodeId,
  } = useNode((node) => ({
    nodeId: node.id,
  }));
  const mediaUpload = useSelector(getMediaUploadForTransaction(nodeId));

  return (
    <StyledImage
      ref={connect}
      className="image-primitive"
      loading="lazy"
      {...props}
      alt={props.alt || ""}
      src={
        mediaUpload?.temporaryUrl ??
        getAssetUrl(props.imageMetadata?.path, props.defaultSrc)
      }
    />
  );
}

const StyledImage = styled.img`
  width: 100%;
`;

Image.craft = {
  custom: {
    displayName: "Image",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
    settings: ImageSettings,
  },
};
